import { evaluateFormula } from "@yjsgames/formula-evaluator";

/**
 * 스탯 증가식 expression 평가 유틸 (Phaser 비의존, 단위 테스트 대상).
 *
 * statUpgrades.tsv 의 `expression` 컬럼 문자열을 받아 `{base}`/`{level}` 플레이스홀더를
 * 각각 base/level 값으로 치환한 뒤 산술 평가하여 스탯 누적 효과값을 반환한다.
 * StatUpgradeController.effect 가 호출 — 기존 `level × effectPerLevel` 선형식을 일반화한 것.
 *
 * 산술 평가(shunting-yard + RPN, CSP-safe)는 @yjsgames/formula-evaluator에 위임 —
 * 여기선 스탯 도메인 placeholder({base}/{level}) 매핑만 담당한다.
 *
 * 예: evalStatExpression("{base} * {level}", 20, 3)        === 60
 *     evalStatExpression("{base} * {level} * 1.01", 1, 3)  === 3.03
 *     evalStatExpression("{base} * 1.01 ** {level}", 100, 2) === 102.01
 */
export function evalStatExpression(expression: string, base: number, level: number): number {
  return evaluateFormula(expression, { base, level });
}
